// components/TaxDetails.jsx
import React from "react";
import Table from "rc-app/components/Table";

const TaxDetails = ({ client, className = "" }: any) => {
  const columns = [
    "Client GSTIN",
    "Client PAN",
    "Invoice collected to date in INR",
    "GST Collected in INR",
    "GST Paid in INR",
  ];

  console.log("TaxDetails", client);

  const renderRow = (client: any, index: number) => (
    <tr
      key={index}
      className="hover:bg-[#35495E] transition-colors text-[#F4F5F7] text-base"
    >
      {/* <td className="px-4 py-3 text-sm font-medium">
        <div className="flex items-center gap-2">
          <UserIcon className="w-5 h-5 text-[#889DB2]" />
          {client.incorporation_year}
        </div>
      </td> */}
      <td className="px-4 py-3 font-semibold">{client?.gstn || "Not Available"}</td>
      <td className="px-4 py-3 font-normal">{client?.pan || "Not Available"}</td>
      <td className="px-4 py-3 font-medium"> 
        {client?.invoice_collected_to_date?.value || "Not Available"}
      </td>
      <td className="px-4 py-3 font-semibold">
        {client?.tax_collected_to_date?.value || "Not Available"}
      </td>
      <td className="px-4 py-3 font-semibold">{client?.tax_paid_to_date?.value || "Not Available"}</td>
    </tr>
  );

  return (
    <Table
      title="Agents"
      columns={columns}
      data={client}
      renderRow={renderRow}
      emptyMessage="No agents available"
      className={className}
      sortableColumns={[0, 1, 2, 3, 4]}
      columnKeys={[
        "gst",
        "pan",
        "invoice_collected_to_date.value",
        "tax_collected_to_date.value",
        "tax_paid_to_date.value",
      ]}  
    />
  );
};

export default TaxDetails;
